(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["inb-prod-warranty"] && !Shopify.designMode) return;
  try {
    (function () {
    if (window.inbDialogBound) return;
    window.inbDialogBound = true;

    document.addEventListener('click', function (event) {
      var opener = event.target.closest('[data-inb-dialog-open]');
      if (opener) {
        var dialog = document.getElementById(opener.getAttribute('data-inb-dialog-open'));
        if (dialog && typeof dialog.showModal === 'function') {
          event.preventDefault();
          if (!dialog.open) dialog.showModal();
        }
        return;
      }

      var closer = event.target.closest('[data-inb-dialog-close]');
      if (closer) {
        var parent = closer.closest('dialog');
        if (parent) parent.close();
        return;
      }

      if (event.target.tagName === 'DIALOG' && event.target.classList.contains('inb-dialog')) {
        event.target.close();
      }
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
